// Mock data for Industrial Hose Manufacturing Website

export const companyInfo = {
  name: "Golden Plastic Industries",
  tagline: "Manufacturers and Exporters of PVC Flexible Pipes, Garden Pipes, Kissan Pipes and Tirpals",
  domain: "goldenpvchose.com",
  experience: "10+ Years",
  description: "Leading manufacturer of PVC flexible pipes, garden pipes, and industrial hoses with over a decade of excellence in quality and service.",
  exports: ["Saudi Arabia", "Dubai", "Peru", "USA", "Mauritius"],
  address: "316, Focal Point, Amritsar, Punjab",
  email: "goldenplastics@gmail.com",
  phone: ["+91-98143-24533", "+91-183-2583191"]
};

export const products = [
  {
    id: 1,
    name: "Clear Zebra Hose",
    description: "Very High-quality transparent hose with zebra pattern for easy visibility and flow monitoring, Extra Superior Quality",
    category: "Specialty Hoses",
    image: "https://customer-assets.emergentagent.com/job_flex-line-1/artifacts/6hx6guh2_Clear%20Zebra%20Hose.png",
    usageImage: "https://customer-assets.emergentagent.com/job_flex-line-1/artifacts/6hx6guh2_Clear%20Zebra%20Hose.png"
  },
  {
    id: 2,
    name: "Clear Plain Hose",
    description: "Transparent hoses for easy visibility and flow material colour monitoring",
    category: "Specialty Hoses",
    image: "https://youconstruct.in/gpi/clear1.png",
    usageImage: "https://youconstruct.in/gpi/clear1.png"
  },
  {
    id: 3,
    name: "Clear Braided Hose",
    description: "Durable coloured braided hoses for high-pressure applications",
    category: "Industrial Hoses",
    image: "https://customer-assets.emergentagent.com/job_flex-line-1/artifacts/43eni4ns_Nylon%20Hose.png",
    usageImage: "https://customer-assets.emergentagent.com/job_flex-line-1/artifacts/43eni4ns_Nylon%20Hose.png"
  },
  {
    id: 4,
    name: "Double coating second quality pipe",
    description: "Extra protection with double layer coating for extreme conditions",
    category: "Pipes",
    image: "https://customer-assets.emergentagent.com/job_flex-line-1/artifacts/qw1hnfm9_Double%20Coating%20hose.png",
    usageImage: "https://customer-assets.emergentagent.com/job_flex-line-1/artifacts/qw1hnfm9_Double%20Coating%20hose.png"
  },
  {
    id: 5,
    name: "Petro quality pipes",
    description: "Certified petro quality pipes for extreme durability with reinforced rubber",
    category: "Pipes",
    image: "https://youconstruct.in/gpi/Petropipe.png",
    usageImage: "https://youconstruct.in/gpi/Petropipe.png"
  },
  {
    id: 6,
    name: "Thomson Pipes",
    description: "Very high long life quality, Extra superior durability",
    category: "Pipes",
    image: "https://youconstruct.in/gpi/thomson.png",
    usageImage: "https://youconstruct.in/gpi/thomson.png"
  },
  {
    id: 7,
    name: "Transparent PVC Colour Hose pipe",
    description: "Transparent colored hoses available in multiple colors for easy identification",
    category: "Pipes",
    image: "https://youconstruct.in/gpi/clearcol.png",
    usageImage: "https://youconstruct.in/gpi/clearcol.png"
  },
  {
    id: 8,
    name: "Semi Braided Hose Pipe",
    description: "Heavy-duty Semi Braided Hose Pipe for industrial applications",
    category: "Industrial Hoses",
    image: "https://youconstruct.in/gpi/semibraid.png",
    usageImage: "https://youconstruct.in/gpi/semibraid.png"
  },

    {
    id: 9,
    name: "Clear Braided Gas Hose",
    description: "Heavy-duty Clear Braided Gas Hose for commercial use",
    category: "Specialty Hoses",
    image: "https://youconstruct.in/gpi/clearbraid.png",
    usageImage: "https://youconstruct.in/gpi/clearbraid.png"
  },
  {
    id: 10,
    name: "Transparent Colour Braided Hose",
    description: "High-Pressure, reinforced PVC tubes designed for visual monitoring of fluids",
    category: "Specialty Hoses",
    image: "https://youconstruct.in/gpi/tcbh.png",
    usageImage: "https://youconstruct.in/gpi/tcbh.png"
  },
    {
    id: 11,
    name: "1/4 mm Hose Pipe",
    description: "For high-pressure air, water, or fuel lines",
    category: "Specialty Hoses",
    image: "https://youconstruct.in/gpi/1mm.png",
    usageImage: "https://youconstruct.in/gpi/1mm.png"
  },
   {
    id: 12,
    name: "Double Braiding TPR Quality Gas Hose",
    description: "For safely transporting gases like LPG, oxygen, or acetylene in industrial and domestic settings.",
    category: "Industrial Hoses",
    image: "https://youconstruct.in/gpi/dc.png",
    usageImage: "https://youconstruct.in/gpi/dc.png"
  },
   {
    id: 13,
    name: "Level Pipe",
    description: "Highly accurate construction tool used to transfer a precise horizontal reference point across long distances",
    category: "Pipes",
    image: "https://youconstruct.in/gpi/level.png",
    usageImage: "https://youconstruct.in/gpi/level.png"
  },
     {
    id: 14,
    name: "Milky Braided Gas Hose",
    description: "To handle pressure and prevent kinking",
    category: "Pipes",
    image: "https://youconstruct.in/gpi/milky.png",
    usageImage: "https://youconstruct.in/gpi/milky.png"
  }
];

export const industries = [
  {
    id: 1,
    title: "Manufacturing",
    description: "Reliable hoses and pipes for manufacturing facilities and production lines",
    icon: "Factory"
  },
  {
    id: 2,
    title: "Agriculture",
    description: "Durable irrigation and water management solutions for agricultural needs",
    icon: "Sprout"
  },
  {
    id: 3,
    title: "Construction",
    description: "Heavy-duty pipes and hoses for construction sites and projects",
    icon: "HardHat"
  },
  {
    id: 4,
    title: "Oil & Gas",
    description: "Certified gas pipes meeting stringent safety and quality standards",
    icon: "Fuel"
  },
  {
    id: 5,
    title: "Chemical Processing",
    description: "Resistant hoses for safe chemical transfer and processing",
    icon: "FlaskConical"
  },
  {
    id: 6,
    title: "Water Treatment",
    description: "Quality pipes and hoses for water treatment and distribution",
    icon: "Droplets"
  }
];

export const qualityStandards = [
  {
    id: 1,
    title: "ISO Certified",
    description: "Manufacturing processes comply with international ISO standards",
    icon: "Award"
  },
  {
    id: 2,
    title: "Quality Testing",
    description: "Rigorous quality checks at every stage of production",
    icon: "ClipboardCheck"
  },
  {
    id: 3,
    title: "Durability Assurance",
    description: "Products tested for long-lasting performance in harsh conditions",
    icon: "Shield"
  },
  {
    id: 4,
    title: "Material Excellence",
    description: "Premium raw materials sourced from trusted suppliers",
    icon: "Gem"
  }
];

export const stats = [
  {
    value: "10+",
    label: "Years Experience"
  },
  {
    value: "5",
    label: "Export Countries"
  },
  {
    value: "8",
    label: "Product Categories"
  },
  {
    value: "100+",
    label: "Happy Clients"
  }
];
